import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('sobreMi', {static: true}) sobreMi: ElementRef;
  @ViewChild('experiencia', {static: true}) experiencia: ElementRef;
  @ViewChild('areas', {static: true}) areas: ElementRef;

  constructor(
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.setSectionOffset();

    this.navigationService.changed.subscribe(() => {
      this.setSectionOffset();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setSectionOffset();
  }

  setSectionOffset(): void {
    const padding = 0;
    this.navigationService.offset['sobre-mi'] = this.sobreMi.nativeElement.offsetTop - padding;
    this.navigationService.offset.experiencia = this.experiencia.nativeElement.offsetTop - padding;
    this.navigationService.offset.areas = this.areas.nativeElement.offsetTop - padding;
    this.navigationService.offset.contacto = document.body.scrollHeight;
  }

  goTo(route: string): void {
    this.navigationService.scrollSection(route);
  }
}
